// Product-card slideshow: each card gets a random 7-10s duration and a
// random start delay, so cards never change in sync.
(function () {
  function stagger() {
    var galleries = document.querySelectorAll('.card-gallery slideshow-component[autoplay]');
    galleries.forEach(function (slideshow) {
      var slides = slideshow.querySelectorAll('slideshow-slide');
      if (slides.length < 2) return;
      var duration = 7 + Math.random() * 3; // 7-10 seconds
      slideshow.setAttribute('autoplay', duration.toFixed(1));
      try { slideshow.pause(); } catch (e) {}
      var delay = Math.random() * duration * 1000;
      setTimeout(function () {
        try { slideshow.play(); } catch (e) {}
      }, delay);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stagger);
  } else {
    stagger();
  }
})();

// Buy Now: add to cart via AJAX then go straight to checkout
function hcBuyNow(btn) {
  var form = btn.closest('form');
  var idInput = form.querySelector('input[name="id"]');
  if (!idInput) return true;
  btn.disabled = true;
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: idInput.value, quantity: 1 })
  }).then(function () {
    window.location.href = '/checkout';
  }).catch(function () {
    form.submit();
  });
  return false;
}
